/**
 * NOS-125: Dashboard CRUD for media_speakers.
 * NOS-262: instantiation of the org-taxonomy factory.
 */
import type { Database } from "@/types/database"
import { makeOrgTaxonomyHook } from "./useOrgTaxonomy"

export type MediaSpeaker = Database["public"]["Tables"]["media_speakers"]["Row"]

export interface MediaSpeakerInput {
  name: string
  title?: string | null
  bio?: string | null
  avatar_url?: string | null
}

export const useMediaSpeakers = makeOrgTaxonomyHook<MediaSpeaker, MediaSpeakerInput>({
  table: "media_speakers",
  orderBy: "name",
  duplicateMessage: "A speaker with this name already exists.",
  deleteGuard: {
    table: "media_video_speakers",
    fk: "speaker_id",
    selectColumn: "video_id",
    message: "Remove this speaker from all videos before deleting.",
  },
  prepare: (v) => ({
    name: v.name.trim(),
    title: v.title?.trim() || null,
    bio: v.bio?.trim() || null,
    avatar_url: v.avatar_url || null,
  }),
})
